(function(){
  var SELLING_PLAN   = 2765652039;
  var AINOTE_PID     = 7481758875719;
  var PRO_VID        = '42616114479175';
  var UNL_VID        = '42616118575175';
  var PRO_BUNDLE_VID = '42676258078791';
  var UNL_BUNDLE_VID = '42682921648199';
  var ALL_MEM_VIDS   = [PRO_VID, UNL_VID, PRO_BUNDLE_VID, UNL_BUNDLE_VID];

  // 原始 VID → bundle VID 映射
  var BUNDLE_MAP = {};
  BUNDLE_MAP[PRO_VID] = PRO_BUNDLE_VID;
  BUNDLE_MAP[UNL_VID] = UNL_BUNDLE_VID;

  /* ── spinner CSS ── */
  (function injectCSS(){
    if(document.getElementById('mc-spinner-style')) return;
    var s = document.createElement('style');
    s.id = 'mc-spinner-style';
    s.textContent =
      '@keyframes mc-spin{to{transform:rotate(360deg)}}' +
      '.mc-loading{position:relative;color:transparent!important;pointer-events:none}' +
      '.mc-loading::after{content:"";position:absolute;width:16px;height:16px;top:50%;left:50%;' +
      'margin:-8px 0 0 -8px;border:2px solid currentColor;border-color:#fff transparent #fff transparent;' +
      'border-radius:50%;animation:mc-spin .7s linear infinite}';
    document.head.appendChild(s);
  })();

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'include' }).then(function(r){ return r.json(); });
  }

  function clearMemberships() {
    return fetchCart().then(function(cart) {
      var memItems = cart.items.filter(function(it) {
        return ALL_MEM_VIDS.indexOf(String(it.variant_id)) !== -1;
      });
      if (!memItems.length) return Promise.resolve();
      return memItems.reduce(function(p, item) {
        return p.then(function() {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });
      }, Promise.resolve());
    });
  }

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, selling_plan: SELLING_PLAN }] })
    }).then(function(r){ return r.json(); });
  }

  /* 检查购物车是否有 AI Note，决定用原始 VID 还是 bundle VID */
  function resolveVid(origVid) {
    return fetchCart().then(function(cart) {
      var hasAiNote = cart.items.some(function(it){ return it.product_id === AINOTE_PID; });
      return hasAiNote ? (BUNDLE_MAP[origVid] || origVid) : origVid;
    });
  }

  function initForms() {
    document.querySelectorAll('form[action*="cart/add"]').forEach(function(form) {
      if (form.dataset.mcInit) return;
      form.dataset.mcInit = '1';

      // 找提交按钮
      var btn = form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
      if (!btn) return;

      // 找 variant ID input
      var vidInput = form.querySelector('input[name="id"]');
      if (!vidInput) return;

      var origVid = vidInput.value;
      // 只处理会员套餐表单
      if (ALL_MEM_VIDS.indexOf(origVid) === -1 && !BUNDLE_MAP[origVid]) return;
      // 确保原始 VID 有对应的 bundle 映射（排除非套餐表单）
      if (!BUNDLE_MAP[origVid]) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        btn.classList.add('mc-loading');
        btn.disabled = true;

        resolveVid(origVid)
          .then(function(vid) {
            return clearMemberships().then(function(){ return cartAdd(vid); });
          })
          .then(function(result) {
            if (result.status) {
              console.error('Cart add error:', result.description);
              btn.classList.remove('mc-loading');
              btn.disabled = false;
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function(e) {
            console.error(e);
            btn.classList.remove('mc-loading');
            btn.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();